// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extrac-more-post .clear-posts{
    background-color: var(--main-color);
    color: white;
    font-weight: bold;
    padding: 9px 22px ;
    border-radius: 22px;
    border: none;
    font-size: 12px;
    margin: 7px 0px;
    cursor: pointer;

}`, "",{"version":3,"sources":["webpack://./src/Pages/ExtractMorePosts/extractMorePosts.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,eAAe;;AAEnB","sourcesContent":[".extrac-more-post .clear-posts{\n    background-color: var(--main-color);\n    color: white;\n    font-weight: bold;\n    padding: 9px 22px ;\n    border-radius: 22px;\n    border: none;\n    font-size: 12px;\n    margin: 7px 0px;\n    cursor: pointer;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
